import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputBaseModel } from '../../models';
import { InputRenderer } from '../../components';
import { NodeProps } from '../../componentTypes';
import { LayoutRenderer } from '../../layout_renderers';
import { NodeIds } from '../../misc';
import { Utils } from '../../../custom_shared/misc';
import { useNodeForm } from '../../hooks';
import { GetComponentRowsFunction } from '../../componentTypes';
import { InputComponentRegistry } from '../../node_inputs';

const InputComponents = InputComponentRegistry[NodeIds.Reinstatements];

const ReinstatementsNodeRenderer: React.FC<NodeProps> = ({ node }: NodeProps) => {
    const { form, formKey, onValuesChange } = useNodeForm(node);

    const getComponentRows: GetComponentRowsFunction = React.useCallback(
        (inputs: InputBaseModel[]) =>
            Utils.groupArray(inputs, 3).map(inputGroup =>
                inputGroup.map(input => ({
                    component: (
                        <InputRenderer
                            key={input.id}
                            input={input}
                            component={InputComponents[input.id as keyof typeof InputComponents]}
                        />
                    )
                }))
            ),
        []
    );

    return (
        <LayoutRenderer
            node={node}
            form={form}
            formKey={formKey}
            onValuesChange={onValuesChange}
            getComponentRows={getComponentRows}
        />
    );
};

export default observer(ReinstatementsNodeRenderer);
